export class InsurancePremiumDetails {
  Id: number;
  PremiumYear: string;
  FromDate: Date;
  ToDate: Date;
  IsActive: boolean;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  PremiumValue: number;
  CompanyContribution: number;
  Active: string;
}
